export default {"src":"/_next/static/media/61973d43f33809e36ca25295_hero-circles-left.38564c22.svg","height":313,"width":276};